import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import classnames from 'classnames'
import Badge from '@material-ui/core/Badge'
import SlotTheme from '../book/slotTheme'
import icons from 'icons'

const BlockedIcon = icons.blocked
const LockedIcon = icons.locked

const useStyles = makeStyles(theme => {
  const slotTheme = SlotTheme(theme)
  return {
    root: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
    },
    reservedSlot: {
      width: '10px',
      height: '10px',
      ...slotTheme.reservedSlot
    },
    partiallyBookedSlot: {
      width: '10px',
      height: '10px',
      ...slotTheme.partiallyBookedSlot
    },
    bookedSlot: {
      width: '10px',
      height: '10px',
      ...slotTheme.bookedSlot
    },
    keyIcon: {
      width: '20px',
      color: '#666'
    }
  }
})

const AdminCalendarKey = ({
  withTitles = true,
  names,
  className,
}) => {

  const classes = useStyles()

  return (
    <div className={ classnames(classes.root, className) }>
      {
        (!names || names.indexOf('hasOverride') >= 0) && (
          <>
            <Badge
              color="secondary"
              variant="dot"
            >
            </Badge>
            {
              withTitles && (
                <>
                  &nbsp;&nbsp;= overidden&nbsp;&nbsp;
                </>
              )
            }
          </>
        )
      }
      {
        (!names || names.indexOf('adminOnlySlot') >= 0) && (
          <>
            <LockedIcon className={ classes.keyIcon } />
            {
              withTitles && (
                <>
                  &nbsp;= admin only&nbsp;&nbsp;
                </>
              )
            }
          </>
        )
      }
      {
        (!names || names.indexOf('blockedSlot') >= 0) && (
          <>
            <BlockedIcon className={ classes.keyIcon } />
            {
              withTitles && (
                <>
                  &nbsp;= blocked&nbsp;&nbsp;
                </>
              )
            }
          </>
        )
      }

      {
        (!names || names.indexOf('reservedSlot') >= 0) && (
          <>
            <div className={ classes.reservedSlot }></div>
            {
              withTitles && (
                <>
                  &nbsp;= reserved&nbsp;&nbsp;
                </>
              )
            }
          </>
        )
      }
      {
        (!names || names.indexOf('partiallyBookedSlot') >= 0) && (
          <>
            <div className={ classes.partiallyBookedSlot }></div>
            {
              withTitles && (
                <>
                  &nbsp;= partially booked&nbsp;&nbsp;
                </>
              )
            }
          </>
        )
      }
      {
        (!names || names.indexOf('bookedSlot') >= 0) && (
          <>
            <div className={ classes.bookedSlot }></div>
            {
              withTitles && (
                <>
                  &nbsp;= booked&nbsp;&nbsp;
                </>
              )
            }
          </>
        )
      }
    </div>    
  )
}

export default AdminCalendarKey